import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { History } from './history'
import { getSearchHistory, DEFAULT_HISTORY } from './storage'

const MAX_HISTORY_COUNT = 10

type SearchHistoryAction = {
  addSearchHistory: (history: History) => void
  deleteSearchHistory: (id: string) => void
  clearSearchHistory: () => void
}

type SearchHistoryState = {
  searchHistory: History[]
  checkSearchHistoryExist: () => boolean
  actions: SearchHistoryAction
}

export const useSearchHistoryStore = create<SearchHistoryState>()(
  persist(
    (set, get) => ({
      searchHistory: getSearchHistory(),
      checkSearchHistoryExist: () => {
        const currentHistory = get().searchHistory

        return currentHistory.length > 0
      },
      actions: {
        addSearchHistory: (newHistory: History) => {
          const currentHistory = get().searchHistory

          const sameHistoryIndex = currentHistory.findIndex(
            history =>
              history.name === newHistory.name &&
              history.startDate === newHistory.startDate &&
              history.endDate === newHistory.endDate,
          )

          if (sameHistoryIndex !== -1) {
            currentHistory.splice(sameHistoryIndex, 1)
          }

          if (currentHistory.length >= MAX_HISTORY_COUNT) {
            currentHistory.pop()
          }

          set({ searchHistory: [newHistory, ...currentHistory] })
        },
        deleteSearchHistory: (id: string) => {
          set({
            searchHistory: get().searchHistory.filter(
              history => history.id !== id,
            ),
          })
        },
        clearSearchHistory: () => {
          set({ searchHistory: DEFAULT_HISTORY })
        },
      },
    }),
    {
      name: 'search-history',
      partialize: state => ({
        searchHistory: state.searchHistory,
      }),
    },
  ),
)
